import { Box, CircularProgress } from '@mui/material';

// Fallback Suspense LOCALIZZATO nell'area contenuto dello shell: nessun
// position:fixed né sfondo opaco, così navbar e SideDrawer restano visibili
// mentre una pagina sospende (chunk interno, sospensioni future). È lo stesso
// pattern del permissions-loading in MainLayout (OutletContent), con la stessa
// minHeight per evitare salti di layout tra i due spinner.
export function ContentAreaSpinner() {
  return (
    <Box
      data-testid="content-area-spinner"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
